//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/ScCollector.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AddCosmeticEnd",1,0],[0,"AllowBroken",1,0],[0,"AssignWeldPMI",1,0],[0,"Associative",1,0],[0,"ConstructionMethod",1,0],[1,"ContourHeight",0,"Expression",0],[0,"ContourType",1,0],[0,"DirectToggle",1,0],[0,"DirectionVector1",1,0],[0,"DirectionVector2",1,0],[0,"DistTolerance",1,0],[1,"EdgeSet1",0,"Section",0],[1,"EdgeSet2",0,"Section",0],[1,"EndDist",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"EndVector",1,0],[0,"EnumMethod",1,0],[0,"ExtendEdges",1,0],[1,"ExtensionDistance",0,"Expression",0],[0,"ExtensionMethod",1,0],[0,"FaceFillGapDistance",1,0],[1,"FaceSet1",0,"ScCollector",0],[1,"FaceSet2",0,"ScCollector",0],[0,"FieldWeld",1,0],[0,"FillFaceHoles",1,0],[0,"FilletType",1,0],[1,"FirstLeg",0,"Expression",0],[1,"NumberOfWelds",0,"Expression",0],[0,"Pmi",1,"NXObject",0],[1,"SecondLeg",0,"Expression",0],[0,"SeedFace1",1,"Face",0],[0,"SeedFace2",1,"Face",0],[0,"SeedPoint1",1,0],[0,"SeedPoint2",1,0],[1,"SegmentLength",0,"Expression",0],[1,"Spacing",0,"Expression",0],[1,"StartDist",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"StartVector",1,0],[0,"ThroatThickToggle",1,0],[0,"ToggleCreateSkipWelds",1,0],[0,"ToggleRecreateDeletedWelds",1,0],[0,"Uparameter1",1,1],[0,"Uparameter2",1,1],[0,"Vparameter1",1,1],[0,"Vparameter2",1,1],[1,"WeldingCharacteristics",0,"Weld.CharacteristicsBuilder",0]],[],[]];
SPLM.Weld.FilletBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.FilletBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.FilletBuilder.EnumExtendEdges = Object.freeze({
    "Manual" : "Manual", "Automatic" : "Automatic"});

SPLM.Weld.FilletBuilder.EnumConstructionMethod = Object.freeze({
    "Default" : "Default", "RollAround" : "RollAround"});

SPLM.Weld.FilletBuilder.EnumExtensionMethod = Object.freeze({
    "Automatic" : "Automatic", "ByValue" : "ByValue"});

SPLM.Weld.FilletBuilder.EnumContour = Object.freeze({
    "None" : "None", "Convex" : "Convex", "Flush" : "Flush", "Concave" : "Concave"});

SPLM.Weld.FilletBuilder.EnumSkipWeldMethod = Object.freeze({
    "NumberLength" : "NumberLength", "NumberSpacing" : "NumberSpacing", "SpacingLength" : "SpacingLength"});

SPLM.Weld.FilletBuilder.EnumWeldingType = Object.freeze({
    "T" : "T", "Lap" : "Lap", "Corner" : "Corner"});

SPLM.Weld.FilletBuilder.EnumFillFaceHolesType = Object.freeze({
    "None" : "None", "Set1" : "Set1", "Set2" : "Set2", "Both" : "Both"});

export default SPLM;